module.exports = __webpack_public_path__ + "media/6-2.04e1e9e4.mp4";